import { clsx } from 'clsx';
import type { ComponentPropsWithoutRef, ReactNode } from 'react';

/** @deprecated Use `EmptyState` from `@storebrand-digital/pretzel` instead. */
export interface StatusLayoutProps extends Omit<
  ComponentPropsWithoutRef<'div'>,
  'children'
> {
  heading: string;
  description?: ReactNode;
  illustration?: ReactNode;
  actions?: ReactNode;
  /**
   * Vertical placement of the content within the full-height container.
   * `'center'` (default) centers it; `'start'` aligns it to the top.
   */
  verticalAlign?: 'center' | 'start';
}

/** @deprecated Use `EmptyState` from `@storebrand-digital/pretzel` instead. */
export const StatusLayout = ({
  illustration,
  heading,
  description,
  actions,
  verticalAlign = 'center',
  className,
  ...rest
}: StatusLayoutProps) => {
  return (
    <div
      {...rest}
      className={clsx(
        'box-border flex h-full flex-col items-center gap-24 md:gap-32',
        verticalAlign === 'center' ? 'justify-center' : 'justify-start',
        className,
      )}
    >
      {illustration && <div>{illustration}</div>}
      <div className="grid gap-heading-near text-center">
        <div className="text-balance">
          {typeof heading === 'string' ? <h1>{heading}</h1> : heading}
        </div>
        {description && (
          <div className="max-w-prose font-body text-pretty grid place-items-center gap-subsection-away">
            {typeof description === 'string' ? (
              <p>{description}</p>
            ) : (
              description
            )}
          </div>
        )}
      </div>
      {actions && (
        <div className="flex flex-wrap items-center justify-center gap-body-away">
          {actions}
        </div>
      )}
    </div>
  );
};
